"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _supportsPassive = _interopRequireDefault(require("./utils/supportsPassive"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var hasWindow = typeof window !== "undefined";
var lastKnownScrollX = 0;
var lastKnownScrollY = 0;
var ticking = false;

var getPosition = function getPosition() {
  return {
    scrollX: hasWindow ? window.pageXOffset : 0,
    scrollY: hasWindow ? window.pageYOffset : 0
  };
};

function useScrollPosition() {
  var _useState = (0, _react.useState)(getPosition()),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var handleScroll = function handleScroll(e) {
    if (!hasWindow) {
      return false;
    }

    lastKnownScrollX = window.pageXOffset;
    lastKnownScrollY = window.pageYOffset;

    if (!ticking) {
      window.requestAnimationFrame(function () {
        setPosition({
          scrollX: lastKnownScrollX,
          scrollY: lastKnownScrollY
        });
        ticking = false;
      });
      ticking = true;
    }
  };

  (0, _react.useEffect)(function () {
    if (!hasWindow) {
      return false;
    }

    window.addEventListener("scroll", handleScroll, _supportsPassive["default"] ? {
      passive: true
    } : false);
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return position;
}

var _default = useScrollPosition;
exports["default"] = _default;